import React, { useState, useEffect } from "react";

import { Field, useFormikContext } from "formik";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";
import {
  Flex,
  FormControl,
  FormErrorMessage,
  Button,
  Grid,
  GridItem,
  Text,
  RadioGroup,
  Stack,
  Box,
  IconButton,
} from "@chakra-ui/react";

import { CustomInputWField } from "../../../../components/CustomInputWField";
import Group from "../../../ServicosAcolhimento/Visualizar/Group";
import { CustomSelectWField } from "../../../../components/CustomSelectWField";
import { forNames } from "../../../../utils/masks";

import { RadioButtonField } from "../../../../components/RadioButtonField";
import CriancaService from "../../../../../main/services/CriancaService";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import { hasFormChanged } from "../../../../utils/hasFormChanged";
import CustomDropzone from "../../../../components/CustomDropzone";
import {
  criancaFunc,
  Permission,
} from "../../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../../Context/AuthProvider";
import { BsFillTrash3Fill } from "react-icons/bs";
import Swal from "sweetalert2";

export const EducacaoCadastrar = ({
  initialValues,
  valuesProps,
  idAnexo,
  idTipoPendencia,
  scrollToField,
}) => {
  const formik = useFormikContext();
  const { setFieldValue, values } = useFormikContext();
  const [, setItems] = useState([{ nome: "", escolaAtual: false }]);
  const unidadesEscolares = values.unidadesEscolares;
  const { setCadastrarEducCrianca } = useAppContext();
  const { roleKeycloack } = useAuthProvider();

  const [escolaridades, setEscolaridades] = useState({
    options: [],
    isLoading: false,
  });

  useEffect(() => {
    if (values.frequentaEscola === "N") {
      const unidadesComNomesPreenchidos = values.unidadesEscolares.filter(
        (unidade) => unidade.nome !== ""
      );

      setFieldValue("idEscolaridade", "");
      setFieldValue("unidadesEscolares", unidadesComNomesPreenchidos);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.frequentaEscola]);

  const [tipoJustificativaEscolaridades, setTipoJustificativaEscolaridades] =
    useState({
      options: [],
      isLoading: false,
    });

  const handleGetTipoEscolaridades = () => {
    setEscolaridades({ ...escolaridades, isLoading: true });

    CriancaService.getCriancaTipoEscolaridade().then((res) => {
      const tempOptions = res.data.map((tipo) => {
        return {
          id: tipo.id,
          descricao: tipo.descricao,
        };
      });
      setEscolaridades({ options: tempOptions, isLoading: false });
    });
  };

  const handleGetTipoJustificativaEscolaridade = () => {
    setTipoJustificativaEscolaridades({
      ...tipoJustificativaEscolaridades,
      isLoading: true,
    });

    CriancaService.getCriancaJustificativaEscolaridade().then((res) => {
      const tempOptions = res.data.map((justificativa) => {
        return {
          id: justificativa.id,
          descricao: justificativa.descricao,
        };
      });
      setTipoJustificativaEscolaridades({
        options: tempOptions,
        isLoading: false,
      });
    });
  };
  const [isSelected, setIsSelected] = useState(
    unidadesEscolares.map((escola) => escola.escolaAtual)
  );

  const handleAddItem = () => {
    formik.setValues({
      ...formik.values,
      unidadesEscolares: [
        ...formik.values.unidadesEscolares,
        isSelected.length === 0
          ? { nome: "", escolaAtual: true, matriculaAnexo: null }
          : { nome: "", escolaAtual: false, matriculaAnexo: null },
      ],
    });

    setIsSelected([...isSelected, isSelected.length === 0]);
  };

  const handleRadioChange = (index) => {
    const updatedSelected = isSelected.map((value, idx) =>
      idx === index ? true : false
    );

    formik.setValues({
      ...formik.values,
      unidadesEscolares: formik.values.unidadesEscolares.map((escola, idx) =>
        idx === index
          ? { ...escola, escolaAtual: true }
          : { ...escola, escolaAtual: false }
      ),
    });
    setIsSelected(updatedSelected);
  };

  const handleDeleteItem = (index) => {
    Swal.fire({
      title: "Atenção!",
      text: "Deseja realmente excluir a unidade escolar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#169499",
      cancelButtonColor: "#169499",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        formik.setValues({
          ...formik.values,
          unidadesEscolares: formik.values.unidadesEscolares.filter(
            (_, i) => i !== index
          ),
        });
      }
    });
  };

  useEffect(() => {
    setIsSelected(unidadesEscolares.map((escola) => escola.escolaAtual));
  }, [unidadesEscolares]);

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  return (
    <Group
      title="Educação"
      border={
        idAnexo === "22" || ["38", "39"].includes(idTipoPendencia)
          ? "3px solid #4299E199"
          : ""
      }
      scrollToField={
        idAnexo === "22" || ["38", "39"].includes(idTipoPendencia)
          ? scrollToField
          : null
      }
    >
      {setCadastrarEducCrianca(hasFormChanged(initialValues, valuesProps))}
      <Grid mt="15px" templateColumns="repeat(3, 1fr)" gap="25px" rowGap="20px">
        <GridItem position="relative" colSpan={{ base: 2, lg: 1 }}>
          <Text
            color="#5F6377"
            fontWeight="500"
            fontSize="14px"
            lineHeight="19.6px"
            htmlFor={"Frequenta Escola?*"}
          >
            Frequenta Escola?*
          </Text>
          <Field name="frequentaEscola">
            {({ field, form }) => (
              <FormControl
                isInvalid={
                  form.errors.frequentaEscola && form.touched.frequentaEscola
                }
                id="frequentaEscola"
                width="max-content"
                position="absolute"
                top="0"
                zIndex={"1"}
                right="-70px"
              >
                <RadioGroup
                  value={field.value}
                  onChange={(value) => {
                    setFieldValue("frequentaEscola", value);
                  }}
                >
                  <Stack direction="row">
                    <RadioButtonField
                      fieldName="frequentaEscola"
                      value="S"
                      label="Sim"
                    />
                    <RadioButtonField
                      fieldName="frequentaEscola"
                      value="N"
                      label="Não"
                    />
                  </Stack>
                </RadioGroup>
                <FormErrorMessage mt="-1" mr="-16">
                  {form.errors.frequentaEscola}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem colSpan={{ lg: 2 }} />
        {values.frequentaEscola === "S" ? (
          <>
            <GridItem position="relative" colSpan={{ base: 2, lg: 1 }}>
              <Text
                color="#5F6377"
                fontWeight="500"
                fontSize="14px"
                lineHeight="19.6px"
                htmlFor={"Educação Especial?*"}
              >
                Educação Especial?*
              </Text>
              <Field name="educacaoEspecial">
                {({ field, form }) => (
                  <FormControl
                    isInvalid={
                      form.errors.educacaoEspecial &&
                      form.touched.educacaoEspecial
                    }
                    id="educacaoEspecial"
                    width="max-content"
                    position="absolute"
                    top="0"
                    zIndex={"1"}
                    right="-70px"
                  >
                    <RadioGroup
                      value={field.value}
                      onChange={(value) =>
                        setFieldValue("educacaoEspecial", value)
                      }
                    >
                      <Stack direction="row">
                        <RadioButtonField
                          fieldName="educacaoEspecial"
                          value="S"
                          label="Sim"
                        />
                        <RadioButtonField
                          fieldName="educacaoEspecial"
                          value="N"
                          label="Não"
                        />
                      </Stack>
                    </RadioGroup>
                    <FormErrorMessage mt="-1" mr="-16">
                      {form.errors.educacaoEspecial}
                    </FormErrorMessage>
                  </FormControl>
                )}
              </Field>
            </GridItem>
            <GridItem colSpan={{ lg: 2 }} />
          </>
        ) : values.frequentaEscola === "N" ? (
          <>
            <GridItem colSpan={"3"}>
              <Box width={{ base: "100%", md: "100%", lg: "700px" }}>
                <CustomSelectWField
                  normal={true}
                  fieldName="idTipoJustificativaEscolaridade"
                  label="Justificativa*"
                  placeholder="Informe a justificativa"
                  getOptionLabel={(option) => option.descricao}
                  getOptionValue={(option) => option.id}
                  isLoading={tipoJustificativaEscolaridades.isLoading}
                  options={tipoJustificativaEscolaridades.options}
                  onChange={(value) => {
                    setFieldValue(
                      "idTipoJustificativaEscolaridade",
                      value ? value : ""
                    );
                  }}
                  onFocus={
                    tipoJustificativaEscolaridades.options.length === 0
                      ? handleGetTipoJustificativaEscolaridade
                      : null
                  }
                />
              </Box>

              {values.idTipoJustificativaEscolaridade.id === 6 && (
                <CustomInputWField
                  fieldName="descricaoJustificativa"
                  placeholder="Informe a justificativa"
                  maxLength={150}
                  messageLength={true}
                  onChange={(e) =>
                    setFieldValue(
                      "descricaoJustificativa",
                      forNames(e.target.value)
                    )
                  }
                />
              )}
            </GridItem>
          </>
        ) : (
          ""
        )}
        {values.frequentaEscola === "S" && (
          <>
            <GridItem position="relative" colSpan={{ base: 2, lg: 1 }}>
              <CustomSelectWField
                fieldName="idEscolaridade"
                label="Escolaridade*"
                placeholder="Selecione a Escolaridade"
                getOptionLabel={(option) => option.descricao}
                getOptionValue={(option) => option.id}
                isLoading={escolaridades.isLoading}
                options={escolaridades.options}
                onChange={(value) => {
                  setFieldValue("idEscolaridade", value ? value : "");
                  setFieldValue("escolaridadeRepetida", value ? "N" : "");
                }}
                onFocus={
                  escolaridades.options.length === 0
                    ? handleGetTipoEscolaridades
                    : null
                }
              />

              <Box
                position={{ base: "relative", sm: "absolute" }}
                top={{ base: 0, sm: "50%" }}
                right={{ base: 0, sm: -170, md: -200 }}
              >
                <RadioButtonField
                  whitespace={true}
                  width={true}
                  fieldName={"escolaridadeRepetida"}
                  value={"S"}
                  label={"Escolaridade Repetida"}
                  educacao={true}
                />
              </Box>
            </GridItem>

            <GridItem colSpan={{ base: 3 }}>
              <RadioGroup
                value={unidadesEscolares.findIndex(
                  (escola) => escola.escolaAtual
                )}
              >
                <Flex
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  gap={1}
                >
                  <Text color="#169499" mb={2}>
                    Unidade Escolar (Histórico)
                  </Text>

                  {unidadesEscolares.length === 0 &&
                  values.frequentaEscola === "S" ? (
                    <Text color="red" opacity={0.8} fontSize="12px">
                      Pelo menos uma escola é obrigatória
                    </Text>
                  ) : (
                    ""
                  )}
                </Flex>
                <Flex gap={4} flexDirection={"column"}>
                  {unidadesEscolares &&
                    unidadesEscolares.length > 0 &&
                    unidadesEscolares.map((item, index) => (
                      <Flex key={index} alignItems={"center"} gap={2}>
                        <Flex
                          border={"solid 1px var(--chakra-colors-gray-200)"}
                          py={5}
                          px={2}
                          justifyContent={"space-between"}
                          flexDirection={{ base: "column", lg: "row" }}
                          flex={1}
                        >
                          <Flex alignItems={"center"} w={{ lg: "65%" }}>
                            <CustomInputWField
                              fieldName={`unidadesEscolares[${index}].nome`}
                              placeholder="Informe a Unidade Escolar"
                              maxLength={255}
                              onChange={(e) =>
                                setFieldValue(
                                  `unidadesEscolares[${index}].nome`,
                                  e.target.value
                                )
                              }
                              isSelected={isSelected[index]}
                              index={index}
                              setFieldValue={setFieldValue}
                              setItems={setItems}
                              escolas={unidadesEscolares}
                              handleRadioChange={() => handleRadioChange(index)}
                            />
                          </Flex>
                          <Box mt={{ base: 4, lg: 0 }}>
                            <CustomDropzone
                              whiteSpace={true}
                              formProps={{ setFieldValue }}
                              title="Comprovante de Matrícula Escolar"
                              fieldName={`unidadesEscolares[${index}].matriculaAnexo`}
                              height="42px"
                              width="auto"
                            />
                          </Box>
                        </Flex>
                        <Permission
                          roleKeycloack={roleKeycloack}
                          func={criancaFunc.escolarExcluir}
                        >
                          <IconButton
                            icon={
                              <BsFillTrash3Fill size={23} color="#9EA1AE" />
                            }
                            aria-label="Excluir"
                            bg="transparent"
                            _hover={{ bg: "transparent" }}
                            size="sm"
                            onClick={() => handleDeleteItem(index)}
                          />
                        </Permission>
                      </Flex>
                    ))}
                </Flex>
              </RadioGroup>

              <Button
                onClick={handleAddItem}
                mt="13px"
                py="5px"
                px="16px"
                h="32px"
                color="#FFF"
                backgroundColor="#169499"
                fontWeight={700}
                fontSize="15px"
                lineHeight="21.6px"
                disabled={values.frequentaEscola === "N"}
                _hover={{ bg: "#169499" }}
              >
                Adicionar
              </Button>
            </GridItem>
          </>
        )}
      </Grid>
    </Group>
  );
};
